import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "main",
      component: () => import("./views/Main.vue"),
      children: [
        {
          path: "",
          name: 'home',
          component: () => import("./views/Home.vue")
        },
        {
          path: "/menu",
          name: "menu",
          component: () => import("./views/Menu.vue")
        },
        {
          path: "/form",
          name: "form",
          component: () => import("./views/Form.vue")
        },
        {
          path: "/addarticle",
          name: "addarticle",
          component: () => import("./views/AddArticle.vue")
        },
        {
          path: "/upload",
          name: "upload",
          component: () => import("./views/Upload.vue")
        },
        {
          path: "/upload2",
          name: "upload2",
          component: () => import("./views/Upload2.vue")
        },
        {
          path: "/role",
          name: "role",
          component: () => import("./views/sys/Role.vue")
        },
        {
          path: "/manager",
          name: "manager",
          component: () => import("./views/sys/Manager.vue")
        },
        {
          path: "/navigation",
          name: "navigation",
          component: () => import("./views/sys/Navigation.vue")
        },
        {
          path: "/siteconfig",
          name: "siteconfig",
          component: () => import("./views/sys/SiteConfig.vue")
        },
        {
          path: "/static/:id",
          name: "static",
          component: () => import("./views/art/Static.vue")
        },
        {
          path: "/artinfo/",
          name: "artinfo",
          component: () => import("./views/art/Info.vue")
        },
        {
          path: "/banner",
          name: "banner",
          component: () => import("./views/base/Banner.vue")
        },
        {
          path: "/category",
          name: "category",
          component: () => import("./views/base/Category.vue")
        },
        {
          path: "/express",
          name: "express",
          component: () => import("./views/base/Express.vue")
        },
        {
          path: "/userlist",
          name: "userlist",
          component: () => import("./views/user/Userlist.vue")
        },
        {
          path: "/collect_year",
          name: "collect_year",
          component: () => import("./views/collect/Year.vue")
        },
        {
          path: "/store",
          name: "store",
          component: () => import("./views/mall/Store.vue")
        },
        {
          path: "/couponrecord",
          name: "couponrecord",
          component: () => import("./views/user/CouponRecord.vue")
        },
        {
          path: "/coupon",
          name: "coupon",
          component: () => import("./views/user/Coupon.vue")
        },
        {
          path:"/cases",
          name:"cases",
          component:()=>import("./views/other/Cases.vue")
        },
        {
          path:"/news",
          name:"news",
          component:()=>import("./views/other/News.vue")
        },
        {
          path:"/consultant",
          name:"consultant",
          component:()=>import("./views/other/Consultant.vue")
        },
        {
          path:"/goods",
          name:"goods",
          component:()=>import("./views/mall/Goods.vue")
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login.vue")
    },
  ]
});
